import { GetScanDataSftpCredentialsWithStoreDetailsListQuery } from '@occc/graphql';

import { GenericSubmissionGroup } from './scan-data-submission-groups.types';

const edgeToEntityMap = (
  edge: NonNullable<
    GetScanDataSftpCredentialsWithStoreDetailsListQuery['listScanDataSftpCredentialsWithStoreDetails']['edges']
  >[0],
) => {
  const node = edge.node;
  return {
    id: node.id,
    title: node.accountIdentifier,
    locations: node.locations?.length ?? 0,
    sftpUsername: node.username,
    submitterId: parseInt(node.submitterID, 10) || 0,
  };
};

export const mapSubmissionGroups = (
  data?: GetScanDataSftpCredentialsWithStoreDetailsListQuery,
): GenericSubmissionGroup[] | undefined => {
  return data?.listScanDataSftpCredentialsWithStoreDetails.edges?.map(edgeToEntityMap);
};
